<template>
  <div class="WorkPlace">
    <header class="header">
      <a-card class="header-left" :bordered="false">
        <div slot="title">
          <img style="width: 20px;vertical-align: sub;" src="@/assets/img/welcome.png" alt="">
          欢迎回来，{{ $store.getters["account/user"].realName }}
        </div>
        <a-card-grid>
          <a-icon type="snippets" theme="twoTone" two-tone-color="#11a5f5" />
          <div>
            <h4>机构数</h4>
            <span class="number">{{ workbenchData.organizationCount }}</span>个
          </div>
        </a-card-grid>
        <a-card-grid>
          <a-icon type="team" style="color: #8f11f5;" />
          <div>
            <h4>学生数</h4>
            <span class="number">{{ workbenchData.organizationUserCount }}</span>个
          </div>
        </a-card-grid>
      </a-card>
      <a-card class="header-right" title="最近访问" :bordered="false">
        <ul>
          <li v-for="item in getRecentVisit" @click="$router.push(item.path)">
            <div>
              <span><a-icon :type="item.icon" /></span>
              <p>{{ item.name }}</p>
            </div>
          </li>
        </ul>
      </a-card>
    </header>
    <div class="student-char">
      <div class="sc-header">
        <h2>学生活跃</h2>
        <a-button-group>
          <a-button :type="searchForm.statisticsType === index ? 'primary' : 'default'"
                    @click="dateChange(index)"
                    v-for="(item, index) in dateType">
            {{ item }}
          </a-button>
        </a-button-group>
      </div>
      <div ref="charBox" style="height: 300px;"></div>
    </div>

    <div class="notice-document">
      <div class="notice">
        <h2 class="notice-head">公告 <span @click="lookAllNotice">查看全部</span></h2>
        <p class="notice-item" :class="{link: item.redirectUrl}"
           v-for="item in modal.data">
          <a-tag :color="levelColor[item.level]">{{ levelName[item.level] }}</a-tag>
          <a @click="toPage(item)" v-if="item.enabled">{{ item.content }}<i
            v-if="item.redirectUrl">&gt;&gt;</i></a>
          <del v-else>{{ item.content }}<i v-if="item.redirectUrl">&gt;&gt;</i></del>
        </p>
      </div>
      <div class="document">
        <h2 class="notice-head">帮助文档</h2>
        <ul>
          <li><a href="https://www.wolai.com/qing2ye/gXoQScCRVyxJhdpmFE5veE" target="_blank">市场反馈</a></li>
          <li><a
            href="https://qr.dingtalk.com/page/yunpan?route=previewDentry&spaceId=22166599903&fileId=0&type=folder"
            target="_blank">实施文档</a></li>
          <li><a href="https://www.wolai.com/qing2ye/idFZRgHWfXQkvYABQHKttW" target="_blank">操作手册</a></li>
          <li><a href="https://www.wolai.com/qing2ye/65giCqDKhftrBcVwAFaWfu" target="_blank">迭代记录</a></li>
        </ul>
      </div>
    </div>

    <a-modal title="公告"
             width="700px"
             :centered="true"
             :footer="null"
             v-model="modal.visible">
      <a-spin :spinning="modal.loading">
        <div class="spin-content" style="min-height: 200px;max-height: 450px;overflow-y: auto;">
          <p class="notice-item" :class="{link: item.redirectUrl}"
             v-for="item in modal.data">
            <a-tag :color="levelColor[item.level]">{{ levelName[item.level] }}</a-tag>
            <a @click="toPage(item)" v-if="item.enabled">{{ item.content }}<i v-if="item.redirectUrl">&gt;&gt;</i></a>
            <del v-else>{{ item.content }}<i v-if="item.redirectUrl">&gt;&gt;</i></del>
          </p>
        </div>
      </a-spin>
      <div style="height: 30px;margin-top: 20px;">
        <a-pagination style="float: right;" @change="getSysNotice"
                      size="small" :total="modal.total"
                      :show-total="total => `共 ${total} 条`" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
export default {
  name: "WorkPlace",
  data() {
    return {
      workbenchData: {},
      searchForm: {
        statisticsType: 0,
      },
      /// 等级 0. 通知 1.关注 2.预警  3.警号
      levelColor: ["green", "blue", "orange", "red"],
      levelName: ["通知", "关注", "预警", "警告"],
      dateType: ["日", "月", "季", "年"],
      modal: {
        data: [],
        visible: false,
        loading: true,
        total: 0,
        page: 1,
      },
    };
  },
  computed:{
    ...mapGetters('account', ['getRecentVisit'])
  },
  mounted() {
    this.getWorkbenchData();
    this.getActivationStatistics();
    this.getSysNotice();
  },
  methods: {
    lookAllNotice() {
      this.modal.visible = true;
      this.getSysNotice();
    },
    dateChange(val) {
      this.searchForm.statisticsType = val;
      this.getActivationStatistics();
    },
    async toPage(val) {
      //类型： 0．通用 1.机构有效期 2．游戏分数异常 3．个人报告生成异常 4．课程资源不足 5．个人报告生成成功
      let path = "";
      const param = JSON.parse(val.param);
      switch (val.type) {
        case 1:
          path = `/projectImpl/pMechanism/orgDetails/page`;
          break;
        case 2:
        case 3:
        case 5:
          const courseId = typeof param === "object" ? param.CustomizeCourseId : param;
          const match = val.content.match(/(?<=“)([^”]+)(?=”)/g);
          const organizationName = Array.isArray(match) ? match[0] : "";
          const courseInfo = await this.$http.CourseService.getOrganizationCourseDetails(courseId);
          this.$store.commit("organization/setCourseInfo", { ...courseInfo.data, organizationName });
          path = `/projectImpl/CourseManage/details/${[3, 5].includes(val.type) ? "userCourse" : "list"}?id=${courseId}`;
          break;
        case 4:
          path = `/projectImpl/pMechanism/orgDetails/page?id=${val.organizationId}&tabActive=${param.CourseType ? param.CourseType - 1 : 0}`;
          break;
      }
      const form = new FormData();
      form.append("id", val.id);
      this.$http.Data.DisableNotice(form);
      val.enabled = false;
      if (path) {
        const { href } = this.$router.resolve({
          path,
        });
        window.open(href, "_blank");
      }
    },
    // 获取系统公告
    getSysNotice(page) {
      const Params = {
        pageIndex: page || this.modal.page,
        pageSize: 10,
      };
      this.modal.loading = true;
      this.$http.User.getSysNotice(Params).then(res => {
        this.modal.loading = false;
        const data = res.data;
        this.modal.data = data.items;
        this.modal.total = data.totalCount;
        this.modal.page = data.pageIndex;
      });
    },
    // 获取活跃人数统计
    getActivationStatistics() {
      this.$http.Data.getActivationStatistics(this.searchForm).then(res => {
        const data = res.data;
        this.$echarts.init(this.$refs.charBox).setOption({
          grid: {
            left: 60,
            right: 40,
            top: 40,
            bottom: 40,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
            },
            className: "echarts-tooltip",
            formatter: function(val) {
              return `<h3>${val[0].name}</h3><div>活跃学生数 <span>${val[0].value}</span></div>`;
            },
          },
          xAxis: {
            type: "category",
            data: data.map(m => m.date),
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true,
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: data.map(m => m.count),
              type: "line",
              smooth: true,
              showSymbol: false,
              lineStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                  offset: 0,
                  color: "rgba(44,233,255)",
                }, {
                  offset: 1,
                  color: "rgb(112,66,251)",
                }]),
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "rgba(32,203,255, 0.4)",
                }, {
                  offset: 1,
                  color: "rgba(32,203,255, 0)",
                }]),
              },
            },
          ],
        });
      });
    },
    // 获取最近访问的菜单
    getWorkbenchData() {
      const Params = {
        adminId: this.$store.getters["account/user"].id,
      };
      this.$http.User.getWorkbenchData(Params).then(res => {
        this.workbenchData = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.WorkPlace {
  padding-bottom: 30px;

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  /deep/ .echarts-tooltip {
    padding: 16px;
    background-color: rgba(255, 255, 255, 0.2) !important;

    h3 {
      font-size: 14px;
      color: #333;
    }

    div {
      font-size: 16px;
      background-color: #fff;
      border-radius: 5px;
      padding: 2px 15px;
    }

    span {
      color: #333;
      margin-left: 20px;
    }
  }

  a {
    color: #666;

    i {
      font-size: initial;
    }
  }

  a:hover {
    color: @primary-color;
  }
}

.header {
  display: flex;
  border-bottom: 1px solid #f0f0f0;

  .ant-card {
    width: 50%;

    &:last-child {
      border-left: 1px solid #ebedf0;
    }
  }

  .header-left .ant-card-grid {
    width: 220px;
    display: flex;
    align-items: center;
    cursor: pointer;

    i {
      flex-shrink: 0;
      font-size: 30px;
      margin-right: 15px;
    }

    h4 {
      margin-bottom: 0;
    }

    .number {
      font-size: 26px;
      font-weight: bold;
      color: #000000;
      margin-right: 5px;
    }
  }

  .header-right {
    /deep/ .ant-card-head-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    ul {
      height: 80px;
      display: flex;
      list-style: none;
      text-align: center;
      flex-wrap: wrap;
      padding: 0;
      overflow: hidden;

      li:not(:first-child) {
        margin-left: 30px;
      }
    }

    span {
      font-size: 22px;
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      background-color: rgba(235, 237, 240, 0.5);
      border-radius: 5px;
      margin-bottom: 5px;
    }

    p {
      margin: 0;
      font-size: 16px;
    }

    div {
      width: 100px;
      cursor: pointer;
      transition: all linear 0.13s;
      margin-bottom: 20px;

      &:hover {
        transform: scale(1.1);
      }

      &:active {
        transform: scale(0.9);
      }
    }
  }
}

.student-char {
  padding: 24px;
  background-color: #fff;

  .sc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;
  }
}

.notice-document {
  display: flex;
  margin-top: 20px;

  .notice {
    flex-grow: 1;
    margin-right: 32px;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  .notice-head span {
    font-size: 14px;
    font-weight: normal;
    color: #11a0f8;
    float: right;
    cursor: pointer;
  }

  .document {
    width: 400px;
    flex-shrink: 0;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  h2 {
    margin-bottom: 20px;
  }

  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    font-size: 16px;

    li {
      width: 50%;
      margin-bottom: 20px;
    }
  }
}

.notice-item {
  margin-bottom: 20px;
  font-size: 16px;

  a {
    color: #666;

    i {
      font-size: initial;
    }
  }

  del {
    color: #ccc;
  }

  a:hover {
    color: @primary-color;
  }
}
</style>
